import { orderSummary } from "../order/actions";
import { ORDER_SUMMARY_FAIL, ORDER_SUMMARY_REQUEST } from "../order/actionType";
import axios from "./utils/axios";

const fetchOrderSummary = (searchDate) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: ORDER_SUMMARY_REQUEST });
      const {
        login: { userInfo },
      } = getState();
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.get(
        `api/order/summary/${searchDate}/`,
        config
      );
      dispatch(orderSummary(data));
    } catch (error) {
      dispatch({
        type: ORDER_SUMMARY_FAIL,
        payload:
          error.response && error.response.data.details
            ? error.response.data.details
            : error.message,
      });
    }
  };
};
export default fetchOrderSummary;
